import { z } from 'zod/v4';

export const addOnOptions = [
  'Unknown',
  'Weather',
  'ITS',
  'TripManagement',
  'HOS',
  'CoPilotDriverCompanionAgent',
] as const;

export const addOnSchema = z.string();

export type AddOn = z.infer<typeof addOnSchema>;
